import React, { useEffect, useState } from "react";
import BasedModal, {
    IProps as ModalProps,
} from "../BaseModalComponents/BasedModal";
import {
    ModalTitle,
    ModalDescription,
} from "components/AreYouSureModal/areYouSureModalStyles";
import { Container, ModalBody } from "components/NewGroupModal/styles";
import { Button, Checkbox, Slider, Tooltip } from "antd";
import {
    BottomButtonsWrapper,
    CheckboxBlockWrapper,
    PickerWithSliderTitle,
    PickerWithSliderWrapper,
} from "./styles";
import { useDispatch } from "react-redux";
import { updateTableSizes } from "store/reducers/TabsSlice";
import { useAppSelector } from "hooks/redux";
const bodyStyle = {
    paddingTop: 15,
    fontSize: 20,
    fontWeight: "bold",
    alignItems: "center",
    width: "400px",
    marginBottom: 15,
};

interface IProps extends ModalProps {
    onRequestClose: () => void;
}

function TableSizesSettingsModal({
    isOpen,
    title,
    description,
    onRequestClose,
    id,
    onApplyClick,
}: IProps) {
    const stateSettings = useAppSelector((state) =>
        state.tabs.tables_sizes.find((s) => s.id === parseInt(id)),
    );
    const [heightValue, setHeightValue] = useState(1); // 0=низкая, 1=средняя, 2=высокая
    const [fontValue, setFontValue] = useState(1);
    const [isAllTablesPicked, setIsAllTablesPicked] = useState(false);
    const [isAutoSizingPicked, setIsAutoSizingPicked] = useState(false);

    const dispatch = useDispatch();

    useEffect(() => {
        if (!stateSettings || !isOpen) return;


    if (stateSettings.row_density) {
        if (stateSettings.row_density === "low") setHeightValue(0);
        else if (stateSettings.row_density === "high") setHeightValue(2);
        else setHeightValue(1); // medium
    }

        let fontIndex = 1;
        if (stateSettings.fontScale) {
            if (stateSettings.fontScale === "small") fontIndex = 0;
            else if (stateSettings.fontScale === "large") fontIndex = 2;
        }

        setFontValue(fontIndex);

        setIsAutoSizingPicked(!!stateSettings.isAutoSizing);
    }, [stateSettings, isOpen]);
    const handleSave = async () => {
            const rowDensity: "low" | "medium" | "high" = 
        heightValue === 0 ? "low" : heightValue === 1 ? "medium" : "high";
        const fontScale: "small" | "medium" | "large" =
            fontValue === 0 ? "small" : fontValue === 1 ? "medium" : "large";

        await dispatch(
            updateTableSizes({
                config_id: parseInt(id),
                rowDensity,
                fontScale,
                autoWidth: isAutoSizingPicked,
                forAll: isAllTablesPicked,
            }),
        );

        onRequestClose();
    };
    return (
        <BasedModal isOpen={isOpen} onRequestClose={onRequestClose}>
            <Container id="tables-sizes-commands-modal-container">
                <ModalBody style={bodyStyle as object}>
                    <ModalTitle>{title}</ModalTitle>
                    {description && (
                        <ModalDescription>{description}</ModalDescription>
                    )}

                    <PickerWithSliderWrapper>
                        <PickerWithSliderTitle>
                            Высота строк
                            <Button onClick={() => setHeightValue(1)}>
                                Сбросить
                            </Button>
                        </PickerWithSliderTitle>
                        <Slider
                            min={0}
                            max={2}
                            step={null}
                            marks={{
                                0: "Низкая",
                                1: "Средняя",
                                2: "Высокая",
                            }}
                            value={heightValue}
                            onChange={setHeightValue}
                            trackStyle={{
                                background: "#7cbe7b",
                            }}
                            handleStyle={{ borderColor: "#7cbe7b" }}
                            tooltip={{ formatter: null }}
                        />
                    </PickerWithSliderWrapper>

                    <PickerWithSliderWrapper>
                        <PickerWithSliderTitle>
                            Размер шрифта
                            <Button onClick={() => setFontValue(1)}>
                                Сбросить
                            </Button>
                        </PickerWithSliderTitle>
                        <Slider
                            min={0}
                            max={2}
                            step={null}
                            marks={{
                                0: "Низкий",
                                1: "Средний",
                                2: "Высокий",
                            }}
                            value={fontValue}
                            onChange={setFontValue}
                            trackStyle={{
                                background: "#7cbe7b",
                            }}
                            handleStyle={{ borderColor: "#7cbe7b" }}
                            tooltip={{ formatter: null }}
                        />
                    </PickerWithSliderWrapper>

                    <Tooltip
                        title="Сброс ручной настройки ширины столбцов 
"
                    >
                        <CheckboxBlockWrapper>
                            <Checkbox
                                checked={isAutoSizingPicked}
                                onChange={(e) =>
                                    setIsAutoSizingPicked(e.target.checked)
                                }
                            >
                                Автоширина всех столбцов
                            </Checkbox>
                        </CheckboxBlockWrapper>
                    </Tooltip>
                    <CheckboxBlockWrapper style={{ margin: "0 0 25px 0" }}>
                        <Checkbox
                            checked={isAllTablesPicked}
                            onChange={(e) =>
                                setIsAllTablesPicked(e.target.checked)
                            }
                        >
                            Применить ко всем таблицам
                        </Checkbox>
                    </CheckboxBlockWrapper>

                    <BottomButtonsWrapper>
                        <Button onClick={onRequestClose}>Отменить</Button>
                        <Button onClick={handleSave}>Сохранить</Button>
                    </BottomButtonsWrapper>
                </ModalBody>
            </Container>
        </BasedModal>
    );
}

export default TableSizesSettingsModal;
